import React, { useEffect, useRef, useState } from "react";
import { useMediaQuery } from "react-responsive";
// import DemoPopup from "./demopopup"; // 👈 import popup
const tabsmob = [
  {
    id: "sf",
    label: "Seamless & Faster",
    img: "/assets/images/kwikwoocomm/s-and-m-mob.png",
  },
  {
    id: "advdis",
    label: "Advanced Discounts",
    img: "/assets/images/kwikwoocomm/discount-mob.png",
  },
  {
    id: "rtofear",
    label: "COD without RTO fears",
    img: "/assets/images/kwikwoocomm/rto-mob.png",
  },
  {
    id: "abtest",
    label: "A/B test to optimize",
    img: "/assets/images/kwikwoocomm/abtest-mob.png",
  },
];

const SectionFive = () => {
  const [activeTab, setActiveTab] = useState(tabsmob[0].id); // default to first tab
  const sectionRefs = useRef({});
  const containerRef = useRef<HTMLDivElement>(null);
  const tabsRef = useRef(null);
  const [showPopup, setShowPopup] = useState(false);
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });
  return (
    <div>
      <div className="section-five-cc">
        <div className="container-fluid">
          <div
            style={{
              alignItems: "center",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <h1 style={{ color: "#003C72" }}>Ship Your Custom Checkout Fast</h1>
          </div>
          {isMobile ? (
            <div>
              {/* Dropdown instead of tabs */}
              <div
                className="dropdown-section-five-mob-cc"
                style={{ marginTop: "20px" }}
              >
                <select
                  value={activeTab}
                  onChange={(e) => setActiveTab(e.target.value)}
                  className="dropdown-mob-five-cc"
                >
                  {tabsmob.map((tab) => (
                    <option key={tab.id} value={tab.id}>
                      {tab.label}
                    </option>
                  ))}
                </select>
              </div>

              {/* Show selected image */}
              <div className="sect-5-cards-mob-cc" ref={containerRef}>
                {tabsmob
                  .filter((tab) => tab.id === activeTab)
                  .map((tab) => (
                    <div key={tab.id} className="card-img-mob active">
                      <img src={tab.img} alt={tab.label} />
                    </div>
                  ))}
              </div>
            </div>
          ) : (
            <div className="container">
              <div className="card-scroll one-cc">
                <img
                  style={{ width: "100%" }}
                  src="/assets/images/checkout-v-one/frame1-check.png"
                  alt=""
                />
              </div>
              <div className="card-scroll two-cc">
                <img
                  style={{ width: "100%" }}
                  src="/assets/images/checkout-v-one/frame2-check.png"
                  alt=""
                />
              </div>
              <div className="card-scroll three-cc">
                <img
                  style={{ width: "100%" }}
                  src="/assets/images/checkout-v-one/frame3-check.png"
                  alt=""
                />
              </div>
              <div className="card-scroll four-cc">
                <img
                  style={{ width: "100%" }}
                  src="/assets/images/checkout-v-one/frame4-check.png"
                  alt=""
                />
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="section-5a-cc">
        <div className="container-fluid">
          <div
            className="flex align-items-center sect-5-cc"
            style={{
              justifyContent: isMobile ? "center" : "space-between",
              gap: "30px",
              margin: isMobile ? "0 0.2rem" : "0 5rem",
              flexDirection: isMobile ? "column" : "row",
            }}
          >
            <div className="mid-text1-cc" style={{ justifyContent: "left" }}>
              <h1>Go live in Minutes!</h1>
              <p
                style={{
                  justifyContent: "left",
                  display: "flex",
                  color: "#0012B7",
                }}
              >
                Low dev effort. No tech delays.
              </p>
            </div>

            <div>
              <button className="cta3-cc" onClick={scrollToTop}>
                Book a Demo
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* <DemoPopup show={showPopup} onClose={() => setShowPopup(false)} /> */}
    </div>
  );
};

export default SectionFive;
